/**
 * Textul din locul codului SE cand cererea in asteptare nu se potriveste, dupa SIIIR, cu nicio
 * scoala existenta: la aprobare primeste cod nou. O scoala care are deja cod il arata pe acela.
 */
export function CodSeLaAprobare() {
    return <span className="text-gray-600">cod nou la aprobare</span>;
}
